import * as _4 from 'lodash4';
export class SectionLabelBadgeController {
  private secion: any;
}

export class SectionLabelBadgeComponent implements angular.IComponentOptions {
  public templateUrl = 'capability-ng-course-schedule/src/components/section_label_badge/section_label_badge.html';
  public bindings = {
    section: '<'
  };
  public controller = SectionLabelBadgeController;
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/components/section_label_badge/section_label_badge_controller.ts